import styled from "styled-components";
import { devices, colors } from "../../../base/styled/variables.styled";
import { typography } from "../../../base/styled/typography.style";
export const PaginationStyle = styled.div `
  &.ps-pagination {
    width: 100%;
    display: flex;
    padding: 40px 0 0;
    align-items: center;
    gap: 16px;
    @media ${devices.mobile} {
      flex-direction: column-reverse;
      margin: 0 auto;
      width: auto;
      gap: 8px;
      padding: 16px 0 0;
    }
    @media ${devices.tablets} {
      flex-direction: column-reverse;
      margin: 0 auto;
      width: auto;
    }
    @media ${devices.desktop} {
      width: 100%;
      justify-content: space-between;
    }

    &--mobile-forced {
      flex-direction: column-reverse;
      margin: 0 auto;
      width: auto;
      gap: 8px;
      padding: 16px 0 0;
    }

    &--compact {
      padding: 0;
      justify-content: flex-start;
      @media ${devices.tablets} {
        flex-direction: row;
        justify-content: center;
      }

      &.ps-pagination--mobile-forced {
        flex-direction: row;
        justify-content: center;
      }
    }

    &--inverse {
      .ps-pagination__label,
      .ps-pagination__compact-label {
        color: ${colors.neutral000};
        strong {
          color: ${colors.neutral000};
        }
      }

      .ps-pagination__items {
        button {
          background-color: transparent;
          color: ${colors.umbuGreen300};
          border-color: ${colors.umbuGreen300};

          &:hover:not(:disabled) {
            background-color: ${`${colors.umbuGreen300}10`};
          }

          &:disabled {
            color: ${`${colors.umbuGreen300}80`};
            border-color: ${`${colors.umbuGreen300}80`};
          }
        }

        li {
          a {
            color: ${colors.umbuGreen300};
            background-color: transparent;
            border-color: ${colors.umbuGreen300};

            &:hover {
              background-color: rgba(231, 247, 158, 0.1);
              border-color: ${colors.umbuGreen300};
            }
          }

          &.selected a {
            background-color: ${colors.umbuGreen300};
            border-color: ${colors.umbuGreen300};
            color: ${colors.brand500};
          }
          &.selected span {
            color: ${colors.brand500};
          }
        }
      }
    }
  }

  .ps-pagination {
    &__compact-label {
      ${typography.body2};
      margin-right: 8px;
      @media ${devices.tablets} {
        text-align: center;
      }

      .ps-pagination--mobile-forced & {
        text-align: center;
      }
    }

    &__label {
      ${typography.body2};
      @media ${devices.mobile} {
        text-align: center;
      }
      @media ${devices.tablets} {
        text-align: center;
      }
      strong {
        font-weight: 700;
      }

      .ps-pagination--mobile-forced & {
        text-align: center;
      }
    }

    &__items {
      display: inline-flex;
      gap: 8px;
      padding: 0;
      margin: 0;
      list-style: none;
      @media ${devices.mobile} {
        gap: 4px;
        justify-content: center;
        padding: 0 4px;
      }
      @media ${devices.tablets} {
        justify-content: center;
      }

      .ps-pagination--mobile-forced & {
        gap: 4px;
        justify-content: center;
        padding: 0 4px;
      }

      button {
        margin: 0;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        font-size: 16px;
        line-height: 24px;
        width: 48px;
        height: 48px;
        border-radius: 8px;
        @media ${devices.mobile} {
          width: 32px;
          height: 32px;
          font-size: 14px;
          min-width: 32px;
          padding: 0;
        }
        @media ${devices.tablets} {
          width: 40px;
          height: 40px;
          padding: 0;
        }

        .ps-pagination--mobile-forced & {
          width: 32px;
          height: 32px;
          font-size: 14px;
          min-width: 32px;
          padding: 0;
        }
      }

      li {
        list-style: none;
        display: inline-block;

        a {
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          ${typography.body2Highlight};
          color: ${colors.brand500};
          width: 48px;
          height: 48px;
          border-radius: 8px;
          @media ${devices.mobile} {
            width: 32px;
            height: 32px;
            font-size: 14px;
            min-width: 32px;
          }
          @media ${devices.tablets} {
            width: 40px;
            height: 40px;
          }

          .ps-pagination--mobile-forced & {
            width: 32px;
            height: 32px;
            font-size: 14px;
            min-width: 32px;
          }

          &:focus-visible {
            outline: none;
            border-radius: 8px;
            border: 0;
          }

          &:hover {
            background-color: ${colors.brand75};
            border-color: ${colors.brand75};
          }
        }

        &.selected a {
          background-color: ${colors.brand500};
          border-color: ${colors.brand500};
          color: ${colors.umbuGreen300};
        }
      }
    }
  }
`;
//# sourceMappingURL=Pagination.style.js.map